import React from "react";
import {translateRequestType, translateRequestStatus} from "../Services";

export const DashboardChartData = (label, data) => {
    return (
        {
            labels: label,
            datasets: [
                {
                    label: 'Chart',
                    fill: false,
                    lineTension: 0.1,
                    backgroundColor: '#B2BBDC',
                    borderColor: '#B2BBDC',
                    borderCapStyle: 'butt',
                    borderDash: [],
                    borderDashOffset: 0.0,
                    borderJoinStyle: 'miter',
                    pointBorderColor: 'rgba(75,192,192,1)',
                    pointBackgroundColor: '#fff',
                    pointBorderWidth: 1,
                    pointHoverRadius: 5,
                    pointHoverBackgroundColor: '#B2BBDC',
                    pointHoverBorderColor: 'rgba(220,220,220,1)',
                    pointHoverBorderWidth: 2,
                    pointRadius: 1,
                    pointHitRadius: 10,
                    data: data
                }
            ]
        }
    )
};

export const TableColumnHeaderMapping = [
    {
        name: 'NIK',
        selector: 'nik',
        wrap: true,
        sortable: true,
        maxWidth: '200px',
        format: row => `${row.nik}`,
    },
    {
        name: 'Nama Lengkap',
        selector: 'fullName',
        wrap: true,
        sortable: true,
        maxWidth: '200px',
        format: row => `${row.fullName.length > 15 ? row.fullName.substring(0, 15) + '...' : row.fullName}`,
    },
    {
        name: 'Layanan',
        selector: 'requestType',
        wrap: true,
        sortable: true,
        maxWidth: '200px',
        format: row => `${translateRequestType(row.requestType)}`,
    },
    {
        name: 'Tanggal',
        selector: 'createDate',
        wrap: true,
        sortable: true,
        maxWidth: '200px',
        format: row => `${row.createdDate}`,
    },
    {
        name: 'Kategori',
        selector: 'category',
        wrap: true,
        sortable: true,
        maxWidth: '200px',
        format: row => `${row.category}`,
    },
    {
        name: 'Nomor Telefon',
        selector: 'phoneNumber',
        wrap: true,
        sortable: true,
        maxWidth: '200px',
        format: row => `${row.phoneNumber}`,
    },
    {
        name: 'Status',
        selector: 'status',
        wrap: true,
        sortable: true,
        button: true,
        cell: (row) => <button className="status-button">{translateRequestStatus(row.requestStatus)}</button>,
    },
];

export const SlkPile = ({icons, title, number}) => {
    return (
        <div className="slk-pile">
            <img className="slk-pile-icons" src={icons} alt=""/>
            <div className="h-spacer"/>
            <div className="slk-pile-text">
                <div className="slk-pile-title">
                    {title}
                </div>
                <div className="slk-pile-number">
                    {number}
                </div>
            </div>
        </div>
    )
}
